// Facebook Pixel, loaded only after the visitor grants Marketing consent.
//
// SEOmatic's own pixel output is switched off in templates/_layouts/base.twig (it would load before consent). The
// Pixel ID is still managed in SEOmatic; the layout passes it here as <body data-fb-pixel-id>.
//
// Consent comes from the Craft Cookie Consent plugin, which is cache-safe (pages are cached by Blitz):
//   - the stored consent is fetched on every page load, exactly like the plugin's own Google Consent Mode snippet,
//     so returning visitors who already accepted are covered even when the banner is not shown;
//   - the plugin's `ccc-loaded` event covers a visitor accepting or changing their choice on this page.
const MARKETING = 'default-marketing'; // cookie group slug (Cookie Consent settings)
const CONSENT_URL = '/cookie-consent/show'; // the endpoint the plugin's own scripts use

const marketingGranted = (consent) => !!consent && (consent[MARKETING] === true || consent[MARKETING] === 'on');
const pixelId = () => (document.body?.dataset.fbPixelId || '').trim(); // read lazily; empty when none is configured

// Facebook's standard bootstrap: defines the fbq queue, then loads fbevents.js asynchronously.
function bootstrapFbq() {
  if (window.fbq) return;
  const fbq = function () { fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments); };
  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
}

let started = false;
function startPixel(id) {
  if (started) { window.fbq('consent', 'grant'); return; } // consent was withdrawn earlier on this page, then given again
  started = true;
  bootstrapFbq();
  window.fbq('init', id);
  window.fbq('track', 'PageView');
}

function apply(consent) {
  if (marketingGranted(consent)) {
    const id = pixelId();
    if (id) startPixel(id);
  } else if (started && window.fbq) {
    window.fbq('consent', 'revoke'); // consent withdrawn on this page: stop sending further events
  }
}

export function initFacebookPixel() {
  window.addEventListener('ccc-loaded', (event) => apply(event.detail));
  fetch(CONSENT_URL, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
    .then((r) => (r.ok ? r.json() : null))
    .then((consent) => apply(consent))
    .catch(() => {}); // no consent state means no pixel
}
